import { Button, Form, Input, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { SendPasswordResetOTPRequest } from "../../api/auth";
import { ErrorMessage } from "../../shared/components/ErrorMessage";

export const SendOTPForm = ({
  onSuccess
}: {
  onSuccess: (email: string) => void | Promise<void>;
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<unknown | null>(null);
  const navigate = useNavigate();

  return <Form<SendPasswordResetOTPRequest>
    layout='vertical'
    onFinish={async (data) => {
      try {
        setSubmitting(true);
        await api.auth.sendPasswordResetOtp(data);
        onSuccess(data.email);
      } catch (e) {
        setError(e);
      } finally {
        setSubmitting(false);
      }
    }}
  >
    <ErrorMessage error={error} />
    <Form.Item
      label="Email"
      name="email"
      rules={[
        { required: true, message: 'email is required' },
        { type: 'email', message: 'must be a valid email' }
      ]}
    >
      <Input />
    </Form.Item>
    <Form.Item>
      <Button
        style={{ width: '100%' }}
        loading={submitting}
        disabled={submitting}
        type="primary"
        size='large'
        htmlType="submit"
      >
        Send OTP
      </Button>
    </Form.Item>


    <Form.Item>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <Typography.Link onClick={(e) => {
          e.preventDefault();
          navigate('/auth/login');
        }}>
          Back to login.
        </Typography.Link>
      </div>
    </Form.Item>
  </Form>;
};
